import * as Sentry from '@sentry/vue';
import { defineStore } from 'pinia';
import { LOCALSTORAGE } from 'src/composables/const';
import { getMe, storeUserSearch } from 'src/services/userService';

export interface IUserStateInterface {
  _id: string | null;
  createdAt: Date | null;
  email: string | null;
  token: string | null;
  points: number;
}

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      _id: null,
      createdAt: null,
      email: null,
      token: null,
      points: 0,
    } as IUserStateInterface;
  },
  getters: {
    isLoggedIn: (state) => !!state.token?.length,
  },
  actions: {
    setToken(token: string | null) {
      this.token = token;
      if (!token) {
        this.email = null;
        this.createdAt = null;
        this._id = null;
      }
    },
    async addPoints(query: string) {
      this.points += 1;
      localStorage.setItem(LOCALSTORAGE.POINTS, this.points.toString());

      try {
        await storeUserSearch(query);
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    async getMe() {
      if (!this.token) {
        const localStoragePoints = localStorage.getItem(LOCALSTORAGE.POINTS);
        this.points = localStoragePoints ? Number(localStoragePoints) : 0;
        return;
      }

      try {
        const res: { data: IUserResult } = await getMe();
        this.points = res.data.points;
        localStorage.setItem(LOCALSTORAGE.POINTS, this.points.toString());
        this._id = res.data._id;
        this.createdAt = new Date(res.data.createdAt);
        this.email = res.data.email;
      } catch (e) {
        Sentry.captureException(e);
      }
    },
  },
});

export interface IUserResult {
  _id: string;
  createdAt: Date;
  email: string;
  points: number;
}
